// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agents/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/agents/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "AI Agent Center" })
  return <Page />
}
